"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const systems_1 = require("@/services/systems");
const systemComponents_1 = require("@/store/ducks/systemComponents");
const systems_2 = require("@/store/ducks/systems");
const listSystemComponentsUseCase_1 = require("./listSystemComponentsUseCase");
function associateSystemComponentsUseCase(systemId, components) {
    return (dispatch) => {
        dispatch((0, systemComponents_1.associateSystemComponents)());
        const componentsToAssociate = components.map((component) => {
            return {
                componentId: component.id,
                lowValueLimit: component.range.lowLimitValue,
                highValueLimit: component.range.highLimitValue,
            };
        });
        const payload = {
            componentsToAssociate: {
                add: [...componentsToAssociate],
            },
        };
        (0, systems_1.patchSystemComponents)(systemId, payload)
            .then(async () => {
            dispatch((0, systemComponents_1.associateSystemComponentsSuccess)());
            dispatch((0, systems_2.openSystemToast)({ status: "success", message: "Components added successfully." }));
            await (0, listSystemComponentsUseCase_1.listSystemComponentsUseCase)(systemId)(dispatch);
            dispatch((0, systemComponents_1.onHideSavePrompt)());
        })
            .catch(() => {
            dispatch((0, systemComponents_1.associateSystemComponentsError)());
            dispatch((0, systems_2.openSystemToast)({
                status: "error",
                message: "Error adding components.",
            }));
        });
    };
}
exports.default = associateSystemComponentsUseCase;
